var _APP_NAMES;

// The values for each key here _might_ be referenced by some binds in the
// products. So they shouldn't be changed from these values.
// As of the date of writing this comment, the product team is only leveraging
// the "agentportal" value.
// - Jim Nielsen, Jun 5, 2019
export var APP_IDS = {
  AGENT_PORTAL: "agentportal",
  IPC_MANAGER: "ipcmanager"
};
export var APP_NAMES = (_APP_NAMES = {}, _APP_NAMES[APP_IDS.AGENT_PORTAL] = "Agent Portal", _APP_NAMES[APP_IDS.IPC_MANAGER] = "IPC Manager", _APP_NAMES); // `loadState` constants for our reducers

export var PRELOAD = "PRELOAD";
export var LOADING = "LOADING";
export var LOADED = "LOADED";
export var LOAD_ERROR = "LOAD_ERROR";
export var RULESET_OUTCOMES = {
  PREVENT: "prevent",
  BLOCK: "block",
  INFORM: "inform"
}; // The strings that come down from launch darkly as feature flags to turn on/off
// specific aspects of Pac.

export var FF_ACTION = "action";
export var FF_RULESETS = "rulesets";
/**
 * The 3 hardest things in computer programming:
 *   1. Cache invalidation
 *   2. Naming things
 *   3. Dates / timezones
 *   4. Off-by-one errors
 *
 * Here we will be dealing with #3: dates.
 *
 * The following are our rules for working with dates:
 *   - Any manifestation of a date in the UI has it's own format
 *   - Any date sent to the server as a <DataItem /> will be in the format
 *     specified by the product team “MM/DD/YYYY” (i.e. any date that flows in
 *     and out of Rex should be in this format)
 *   - Non-product related dates, like <StartDate> will be ISO8601 format “YYYY-MM-DD"
 *
 * Note: these are moment.js token strings for .format()
 */

export var DATE_FORMAT_UI = "MM/DD/YYYY";
export var DATE_FORMAT_PRODUCT = "MM/DD/YYYY";
export var DATE_FORMAT_ISO8601 = "YYYY-MM-DD";